import { render, staticRenderFns } from "./article-edit.vue?vue&type=template&id=7ae774c5&scoped=true&"
import script from "./article-edit.vue?vue&type=script&lang=js&"
export * from "./article-edit.vue?vue&type=script&lang=js&"
import style0 from "./article-edit.vue?vue&type=style&index=0&id=7ae774c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae774c5",
  null
  
)

export default component.exports